








import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import ContingentSettingsForm from "./ContingentSettingsForm.vue";
import RightDrawer from "@/components/misc/RightDrawer.vue";

@Component({ components: { ContingentSettingsForm, RightDrawer } })
export default class Settings extends Vue {
  @Getter("contingent/isLoading") loading?: boolean;
  @Getter("contingent/settingsOpen") settingsOpen?: boolean;
  @Action("contingent/openSettings") open?: () => void;
}
